export default "__VITE_ASSET__DP10T$HB__"